import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PersonalService} from '../personal/personal.service';
import {FabMessageService} from '@fabric/components/message';
import {MatPaginator} from '@angular/material/paginator';
import {WorkAbroadService} from '../work-abroad/work-abroad.service';
import {Vacation} from "../admin/models/vacation.model";
import {WorkAbroad} from "../admin/models/workAbroad.model";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
    selector: 'app-cancel-pop-up',
    templateUrl: './cancel-pop-up.component.html',
    styleUrls: ['./cancel-pop-up.component.scss']
})
export class CancelPopUpComponent implements OnInit {

    public requestID = '';
    public requestType = '';
    public requestStatus = '';
    public vacation = {} as Vacation;
    public work = {} as WorkAbroad;
    public isPageLoading = false;

    @ViewChild(MatPaginator) paginator: MatPaginator | undefined;

    constructor(public dialogRef: MatDialogRef<[]>,
                private readonly fabMessageService: FabMessageService,
                private readonly personalService: PersonalService,
                private readonly workAbroadService: WorkAbroadService,
                @Inject(MAT_DIALOG_DATA) public selectedData: any) {
    }

    ngOnInit(): void {
        this.requestID = this.selectedData.vacationID;
        this.requestType = this.selectedData.requestType;
        this.requestStatus = this.selectedData.requestStatus;
        this.vacation = this.selectedData.vacation;
        this.work = this.selectedData.workAbroad;
    }

    close(): void {
        this.dialogRef.close();
    }

    /**
     * Submits a request to the api to cancel a vacation
     * Checks whether the request is for a work abroad or a vacation(personal request)
     */
    public cancelRequest(): void {
        this.isPageLoading = true;
        if (this.requestType === 'PERSONAL') {
            this.personalService.cancelVacationRequest(this.requestID).subscribe({
                next: () => {
                    this.isPageLoading = false;
                    this.fabMessageService.displayMessage('Cancel request submitted successfully');
                    this.close();

                }, error: (err: HttpErrorResponse) => {
                    this.isPageLoading = false;
                    this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                    this.close();
                }
            });
        } else if (this.requestType === 'WORKABROAD') {
            this.workAbroadService.cancelWorkAbroadRequest(this.requestID).subscribe({
                next: () => {
                    this.isPageLoading = false;
                    this.fabMessageService.displayMessage('Delete request submitted successfully');
                    this.close();
                }, error: (err: HttpErrorResponse) => {
                    this.isPageLoading = false;
                    this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                    this.close();
                }
            });
        }
    }

    public cancelApprovedRequest(): void {
        this.isPageLoading = true;
        if (this.requestType === 'PERSONAL') {
            this.vacation.requestStatus = 'CANCEL_REQUEST';
            this.vacation.startDate = this.personalService.convertDateFormatForAPI(this.vacation.startDate);
            this.vacation.endDate = this.personalService.convertDateFormatForAPI(this.vacation.endDate);
            this.cancelApprovedVacationRequest(this.vacation);
        } else if (this.requestType === 'WORKABROAD') {
            this.work.requestStatus = 'CANCEL_REQUEST';
            this.work.startDate = this.personalService.convertDateFormatForAPI(this.work.startDate);
            this.work.endDate = this.personalService.convertDateFormatForAPI(this.work.endDate);
            if (this.work.vacations) {
                this.work.vacations.forEach((i) => {
                    i.requestStatus = 'CANCEL_REQUEST';
                    this.cancelApprovedVacationRequest(i);
                });
            }
            this.workAbroadService.modifyWorkAbroadRequest(this.work).subscribe({
                next: () => {
                    this.isPageLoading = false;
                    this.fabMessageService.displayMessage('Cancel request submitted successfully');
                    this.close();
                }, error: (err: HttpErrorResponse) => {
                    this.isPageLoading = false;
                    this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                    this.close();
                }
            });
        }
    }

    public cancelApprovedVacationRequest(data: Vacation) {
        this.personalService.modifyVacationRequest(data).subscribe({
            next: () => {
                this.isPageLoading = false;
                this.fabMessageService.displayMessage('Cancel request submitted successfully');
                this.close();
            }, error: (err: HttpErrorResponse) => {
                this.isPageLoading = false;
                this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                this.close();
            }
        });
    }
}
